<template>
  <v-form>
    <v-container>
      <span v-if="editMotorTypeId == -1" class="headline">Create Motor Type</span>
      <span v-if="editMotorTypeId != -1" class="headline">Edit Motor Type</span>

      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motorType.type" label="Type"></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.frequency" label="Frequency"></v-text-field>
        </v-col> -->

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.phase" label="Phase"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motorType.voltage"
            suffix="V"
            label="Voltage"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.fi_d_max" suffix="mm" label="Fi D Max"></v-text-field>
        </v-col>

        
      </v-row>

      
          <v-row>
    <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motorType.max_water_temp"
            suffix="C"
            label="Maximum Water Temp"
          ></v-text-field>
        </v-col>  

            <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.degree_of_protection" suffix="" label="Degree Of Protection"></v-text-field>
        </v-col>  
         </v-row>
        
       
      <div class="my-2">
        <v-btn v-if="editMotorTypeId == -1" color="primary" @click="saveMotorType">Save</v-btn>
        <v-btn v-if="editMotorTypeId != -1" color="primary" @click="saveMotorType">Update</v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "MotorTypesAdd",

  data: () => ({
    token: "",
    query: "",
    motorType: {
      idmotor_type: -1,
      type: "XSM 20",
      frequency: 50,
      phase: 3,
      voltage : "100-200",
      fi_d_max : 200,
      degree_of_protection : "IP 68",
      max_water_temp : "30",
    } 
  }),

  props: {
    editMotorTypeId: {
      type: String,
      default: "-1"
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    if ( this.editMotorTypeId != -1){
        this.fetchMotorType(this.editMotorTypeId)
      }
  },
  methods: {
    fetchMotorType: function(editMotorTypeId) {
      this.$http.get(this.$API_URL + "motor_type?idmotor_type=" + editMotorTypeId).then(result => {
        this.motorType = result.data
      });
    },
    saveMotorType: function() {
      var targetUrl = this.editMotorTypeId == -1 ? "save_motor_type" : "update_motor_type";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.motorType
      })
        .then(function(response) {
          console.log(response.data)
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    },

     
  }
};
</script>
